import React, { useState, useEffect } from "react";

import { useTodosContext } from "../../context/todoContext";

import Wrapper from "./TodosActions.styled";

const TodosActions = () => {
  const { totalTodos, filters, filterTodos, clearCompleted } =
    useTodosContext();
  const [filter, setFilter] = useState(filters);

  const onFilter = (e) => {
    const { name, value } = e.target;

    setFilter(value);
    filterTodos(value);
  };

  return (
    <Wrapper>
      <span className="action__left">{totalTodos} items left</span>
      <div className={`todos__filters ${filters}`}>
        <div className="todos__filters-radio">
          <input
            className="filter-input"
            type="radio"
            name="filters"
            value="all"
            id="all"
            onChange={onFilter}
            checked={filter === "all"}
          />
          <label htmlFor="all">All</label>
        </div>
        <div className="todos__filters-radio">
          <input
            className="filter-input"
            type="radio"
            name="filters"
            id="active"
            value="active"
            onChange={onFilter}
            checked={filter === "active"}
          />
          <label htmlFor="active">Active</label>
        </div>
        <div className="todos__filters-radio">
          <input
            className="filter-input"
            type="radio"
            name="filters"
            id="completed"
            value="completed"
            onChange={onFilter}
            checked={filter === "completed"}
          />
          <label htmlFor="completed">Completed</label>
        </div>
      </div>
      <button className="btn btn-clear" onClick={clearCompleted}>
        Clear Completed
      </button>
    </Wrapper>
  );
};

export default TodosActions;

/* 
 
*/
